/* Rescuevation · Standard-Produktkopf (rescu-stk-*), 19.10.2026

   Ohne JavaScript funktioniert der Kopf vollständig: Varianten sind Radios
   name="id", das Formular schickt klassisch an /cart/add, die Weiche in
   Aufbau B läuft über CSS :has(). Dieses Script ergänzt:
   Galerie (Wischen, Pfeile, Vorschaubilder, Lupe), Variantenwechsel (Preis,
   Art.-Nr., Lagerstatus, Bild, URL, Sticky-Leiste), Mengen, Warenkorb über
   /cart/add.js mit der Live-Schublade, Angebots-Vorbefüllung des
   Kontaktformulars, Lieferdatum und die Für-wen-Chips.

   Warenkorb: Die Section-Liste kommt von der Schublade selbst
   (getSectionsToRender), weil die Live-Schublade b4c andere Sections rendert
   als Dawns Standard. Ist der Artikel schon im Korb und nur das Rendern
   scheitert, geht es nach /cart, nie ein zweites Mal ins Formular.

   Bewegung ist ADDITIV und entfällt bei reduzierter Bewegung. */
(function () {
  'use strict';
  if (window.__rstk) return;
  window.__rstk = true;

  var doc = document.documentElement;
  doc.classList.add('stk-js');
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var feinZeiger = window.matchMedia('(pointer: fine)').matches;
  var geldFmt = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var alle = function (wurzel, sel) { return Array.prototype.slice.call(wurzel.querySelectorAll(sel)); };
  var euro = function (cent) { return geldFmt.format(cent / 100) + ' €'; };
  var brutto = function (cent) { return Math.round(cent * 1.19); };
  var neuStarten = function (el, klasse) {
    if (!el || ruhig) return;
    el.classList.remove(klasse);
    void el.offsetWidth;
    el.classList.add(klasse);
  };

  /* ---------- Galerie ---------- */

  function galerie(g) {
    var band = g.querySelector('[data-stk-band]');
    if (!band) return null;
    var bilder = alle(band, '[data-stk-slide]');
    var minis = alle(g, '[data-stk-mini]');
    var zaehler = g.querySelector('[data-stk-zaehler]');
    var aktuell = 0;
    function gehe(i) {
      if (!bilder.length) return;
      i = (i + bilder.length) % bilder.length;
      band.scrollTo({ left: bilder[i].offsetLeft, behavior: ruhig ? 'auto' : 'smooth' });
    }
    function markieren() {
      var i = Math.round(band.scrollLeft / Math.max(1, band.clientWidth));
      if (i === aktuell) return;
      aktuell = i;
      minis.forEach(function (m, n) { m.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (zaehler) zaehler.textContent = String(i + 1);
      var m = minis[i];
      if (m && m.parentElement) {
        var reihe = m.parentElement;
        reihe.scrollTo({ left: m.offsetLeft - reihe.clientWidth / 2 + m.clientWidth / 2, behavior: ruhig ? 'auto' : 'smooth' });
      }
      // Laufende Videos anhalten, wenn weitergeblättert wird
      alle(band, 'video').forEach(function (v) { if (!v.paused) v.pause(); });
    }
    band.addEventListener('scroll', function () { window.requestAnimationFrame(markieren); }, { passive: true });
    minis.forEach(function (m, i) { m.addEventListener('click', function () { gehe(i); }); });
    var vor = g.querySelector('[data-stk-vor]');
    var zurueck = g.querySelector('[data-stk-zurueck]');
    if (vor) vor.addEventListener('click', function () { gehe(aktuell + 1); });
    if (zurueck) zurueck.addEventListener('click', function () { gehe(aktuell - 1); });
    band.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); gehe(aktuell + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); gehe(aktuell - 1); }
    });
    return {
      zuMedia: function (id) {
        if (!id) return;
        for (var i = 0; i < bilder.length; i++) {
          if (bilder[i].getAttribute('data-media-id') === String(id)) { gehe(i); return; }
        }
      }
    };
  }

  function lupe(kopf) {
    var dialog = kopf.querySelector('[data-stk-lupe-dialog]');
    var bild = dialog && dialog.querySelector('[data-stk-lupe-bild]');
    if (!dialog || !bild || typeof dialog.showModal !== 'function') return;
    alle(kopf, '[data-stk-lupe]').forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        var img = knopf.querySelector('img');
        bild.src = knopf.getAttribute('data-gross') || (img && img.currentSrc) || '';
        bild.alt = img ? img.alt : '';
        dialog.showModal();
      });
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }

  /* ---------- Lieferdatum ---------- */

  function werktageSpaeter(n) {
    var d = new Date();
    var gezaehlt = 0;
    while (gezaehlt < n) {
      d.setDate(d.getDate() + 1);
      var t = d.getDay();
      if (t !== 0 && t !== 6) gezaehlt++;
    }
    return d;
  }
  function lieferdatum(kopf, T) {
    var tagFmt;
    try { tagFmt = new Intl.DateTimeFormat(T.datum || 'de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' }); }
    catch (e) { tagFmt = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' }); }
    alle(kopf, '[data-stk-lager]').forEach(function (p) {
      var ziel = p.querySelector('[data-stk-liefer]');
      if (!ziel || p.classList.contains('stk-lager--aus')) return;
      if (p.hasAttribute('data-fest')) { ziel.textContent = p.getAttribute('data-fest'); return; }
      var min = parseInt(p.getAttribute('data-min'), 10) || 5;
      var max = parseInt(p.getAttribute('data-max'), 10) || 10;
      ziel.textContent = (T.zustellung || 'Zustellung voraussichtlich') + ' ' + tagFmt.format(werktageSpaeter(min)) + ' ' + (T.bis || 'bis') + ' ' + tagFmt.format(werktageSpaeter(max));
    });
  }

  /* ---------- Warenkorb ---------- */

  function inDenWarenkorb(items) {
    var schublade = document.querySelector('cart-drawer');
    var body = { items: items };
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      body.sections = schublade.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (daten) {
        if (!res.ok || daten.status) {
          var fehler = new Error(daten.description || daten.message || 'HTTP ' + res.status);
          fehler.abgelehnt = true;
          throw fehler;
        }
        return daten;
      });
    }).then(function (daten) {
      try {
        if (schublade && typeof schublade.renderContents === 'function' && daten.sections) {
          schublade.classList.remove('is-empty');
          schublade.renderContents(daten);
        } else {
          window.location.href = root + 'cart';
        }
      } catch (e) {
        window.location.href = root + 'cart';
      }
      return daten;
    });
  }

  var HAKEN = '<svg class="stk-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.5l4.8 4.8L19.5 7"/></svg>';

  /* ---------- Kopf ---------- */

  function kopf(sec) {
    var modus = sec.getAttribute('data-modus') || 'netto';
    // Feste Texte der Seitensprache aus dem Sprachblock der Section (rescu-stk-kopf.liquid)
    var T = {};
    try { T = JSON.parse(sec.getAttribute('data-stk-t') || '{}'); } catch (e) { T = {}; }
    var form = sec.querySelector('[data-stk-form]');
    var gal = sec.querySelector('[data-stk-galerie]');
    var galerieSteuerung = gal ? galerie(gal) : null;
    lupe(sec);
    lieferdatum(sec, T);

    var btn = form && form.querySelector('[data-stk-submit]');
    var btnText = btn && btn.querySelector('[data-stk-submit-text]');
    var fehler = form && form.querySelector('[data-stk-fehler]');
    var lager = sec.querySelector('[data-stk-lager]');

    function gewaehlt() {
      if (!form) return null;
      var r = form.querySelector('[data-stk-variante]:checked') || form.querySelector('[data-stk-einzeln]');
      if (!r) return null;
      return {
        el: r,
        id: parseInt(r.value, 10),
        preis: parseInt(r.getAttribute('data-preis'), 10) || 0,
        streich: parseInt(r.getAttribute('data-streich'), 10) || 0,
        sku: r.getAttribute('data-sku') || '',
        name: r.getAttribute('data-name') || '',
        verfuegbar: r.getAttribute('data-verfuegbar') !== '0',
        media: r.getAttribute('data-media')
      };
    }
    function menge() {
      var feld = sec.querySelector('[data-stk-menge]');
      return feld ? Math.max(1, parseInt(feld.value, 10) || 1) : 1;
    }

    /* Mengen: alle Stepper des Kopfs zeigen denselben Wert */
    var stepperFelder = alle(sec, '[data-stk-menge], [data-stk-menge-angebot]');
    function mengeSetzen(n) {
      n = Math.max(1, Math.min(999, n || 1));
      stepperFelder.forEach(function (f) { f.value = String(n); });
    }
    alle(sec, '.stk-stepper').forEach(function (st) {
      var feld = st.querySelector('input');
      var minus = st.querySelector('[data-stk-minus]');
      var plus = st.querySelector('[data-stk-plus]');
      if (minus) minus.addEventListener('click', function () { mengeSetzen((parseInt(feld.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { mengeSetzen((parseInt(feld.value, 10) || 1) + 1); });
      feld.addEventListener('change', function () { mengeSetzen(parseInt(feld.value, 10)); });
    });

    /* Variantenwechsel */
    function varianteAnzeigen(v, neu) {
      if (!v) return;
      var haupt = modus === 'brutto' ? brutto(v.preis) : v.preis;
      var zweit = modus === 'brutto' ? v.preis : brutto(v.preis);
      var betrag = sec.querySelector('[data-stk-betrag]');
      var zweitEl = sec.querySelector('[data-stk-zweit]');
      var streich = sec.querySelector('[data-stk-streich]');
      if (betrag) betrag.textContent = euro(haupt);
      if (zweitEl) zweitEl.textContent = euro(zweit);
      if (streich) {
        streich.hidden = !(v.streich > v.preis);
        streich.textContent = euro(modus === 'brutto' ? brutto(v.streich) : v.streich);
      }
      if (neu) neuStarten(sec.querySelector('[data-stk-preis]'), 'ist-neu');
      var sku = sec.querySelector('[data-stk-sku]');
      if (sku && v.sku) sku.textContent = v.sku;
      var name = sec.querySelector('[data-stk-wahl-name]');
      if (name && v.name) name.textContent = v.name;
      if (btn) {
        btn.disabled = !v.verfuegbar;
        if (btnText) btnText.textContent = v.verfuegbar ? (T.warenkorb || 'In den Warenkorb') : (T.nicht_bestellbar || 'Derzeit nicht bestellbar');
      }
      if (lager) {
        lager.classList.toggle('stk-lager--aus', !v.verfuegbar);
        var status = lager.querySelector('[data-stk-lager-status]');
        var liefer = lager.querySelector('[data-stk-liefer]');
        if (status) status.textContent = v.verfuegbar ? (T.bestellbar || 'Bestellbar') : (T.nicht_vorraetig || 'Derzeit nicht vorrätig');
        if (liefer && !v.verfuegbar) liefer.textContent = T.nicht_vorraetig_text || 'Fordere ein Angebot an, wir melden uns mit dem Liefertermin.';
        if (v.verfuegbar) lieferdatum(sec, T);
      }
      // Aufbau B: nicht bestellbare Ausführung führt in den Angebotsweg
      if (!v.verfuegbar) {
        var weg = sec.querySelector('[data-stk-weg-wahl][value="angebot"]');
        if (weg) weg.checked = true;
      }
      // Sticky-Leiste (rescu-sticky-cta) zeigt den Nettopreis
      alle(document, '[data-sticky-preis]').forEach(function (p) { p.textContent = euro(v.preis); });
      if (neu && galerieSteuerung && v.media) galerieSteuerung.zuMedia(v.media);
      if (neu && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', String(v.id));
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* alte Browser: URL bleibt */ }
      }
    }
    if (form) {
      alle(form, '[data-stk-variante]').forEach(function (r) {
        r.addEventListener('change', function () {
          var v = gewaehlt();
          varianteAnzeigen(v, true);
          neuStarten(r.closest('.stk-option'), 'ist-neu');
        });
      });
      varianteAnzeigen(gewaehlt(), false);
    }

    /* Kaufen */
    if (form && btn) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        var v = gewaehlt();
        if (!v) { form.submit(); return; }
        if (fehler) { fehler.hidden = true; fehler.textContent = ''; }
        var label = btn.innerHTML;
        btn.setAttribute('aria-disabled', 'true');
        btn.innerHTML = '<span></span>';
        btn.firstChild.textContent = T.laeuft || 'Wird hinzugefügt …';
        inDenWarenkorb([{ id: v.id, quantity: menge() }]).then(function () {
          btn.removeAttribute('aria-disabled');
          btn.classList.add('ist-ok');
          btn.innerHTML = HAKEN + '<span></span>';
          btn.lastChild.textContent = T.im_korb || 'Im Warenkorb';
          setTimeout(function () { btn.classList.remove('ist-ok'); btn.innerHTML = label; }, 2400);
        }).catch(function (err) {
          btn.removeAttribute('aria-disabled');
          btn.innerHTML = label;
          if (err && err.abgelehnt) {
            if (fehler) { fehler.textContent = err.message; fehler.hidden = false; }
          } else {
            // Netzfehler vor dem Hinzufügen: klassisch absenden
            form.submit();
          }
        });
      });
    }

    /* Angebot anfordern: Kontaktformular mit der Auswahl vorbefüllen */
    var VORLAGE = 'stkVorbefuellt';
    alle(sec, '[data-stk-angebot]').forEach(function (a) {
      a.addEventListener('click', function () {
        var feld = document.getElementById('ContactForm-body');
        if (!feld) return;
        if (feld.value.trim() !== '' && !feld.dataset[VORLAGE]) return;
        var v = gewaehlt();
        var produkt = sec.getAttribute('data-produkt') || document.title;
        var zeile = (T.angebot_zeile || 'Ich möchte ein Angebot für') + ' ' + menge() + ' × ' + produkt;
        if (v && v.name && v.name !== 'Default Title') zeile += ' (' + v.name + ')';
        if (v && v.sku) zeile += ', ' + (T.artnr || 'Art.-Nr.') + ' ' + v.sku;
        feld.value = zeile + '.\n\n' + (T.adresse || 'Lieferadresse / Feuerwehr, Behörde oder Betrieb:') + '\n';
        feld.dataset[VORLAGE] = '1';
        setTimeout(function () { try { feld.focus({ preventScroll: true }); } catch (e) { /* egal */ } }, 600);
      });
    });

    /* Aufbau B: Für-wen-Chips markieren die passende Einsatzkarte */
    var chips = alle(sec, '[data-stk-chip]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        var nr = chip.getAttribute('data-stk-chip');
        var karte = sec.querySelector('[data-stk-einsatz="' + nr + '"]');
        if (!karte) return;
        e.preventDefault();
        chips.forEach(function (c) { c.setAttribute('aria-current', c === chip ? 'true' : 'false'); });
        alle(sec, '[data-stk-einsatz]').forEach(function (k) { k.classList.toggle('ist-aktiv', k === karte); });
        var r = karte.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) {
          karte.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'center' });
        }
      });
    });

    /* Aufbau C: Plaketten glänzen einmal, Lichtfleck folgt der Maus */
    var plaketten = sec.querySelector('.stk-plaketten');
    if (plaketten && !ruhig) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (eintraege) {
          if (eintraege[0].isIntersecting) { plaketten.classList.add('stk-go'); io.disconnect(); }
        }, { threshold: 0.4 });
        io.observe(plaketten);
      } else {
        plaketten.classList.add('stk-go');
      }
    }
    if (sec.querySelector('.stk-kopf__spot') && feinZeiger && !ruhig) {
      sec.addEventListener('pointermove', function (e) {
        window.requestAnimationFrame(function () {
          var r = sec.getBoundingClientRect();
          sec.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          sec.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        });
      });
    }
  }

  function start() { alle(document, '[data-stk-kopf]').forEach(kopf); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
